import { render, staticRenderFns } from "./VQuestionInfo.vue?vue&type=template&id=5d4d5e7e"
import script from "./VQuestionInfo.vue?vue&type=script&lang=js"
export * from "./VQuestionInfo.vue?vue&type=script&lang=js"
import style0 from "./VQuestionInfo.vue?vue&type=style&index=0&id=5d4d5e7e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4d5e7e')) {
      api.createRecord('5d4d5e7e', component.options)
    } else {
      api.reload('5d4d5e7e', component.options)
    }
    module.hot.accept("./VQuestionInfo.vue?vue&type=template&id=5d4d5e7e", function () {
      api.rerender('5d4d5e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/VQuestionInfo.vue"
export default component.exports